// Chat intent derivation (Design Bible D11) — map a Stream channel to one of the
// six canonical conversation intents so the DM-tab intent chips can filter and
// count. Reuses the single intent vocabulary from messageRequestApi (keys +
// labels + pill colours) so chips, request cards and this filter never drift.

import { MESSAGE_REQUEST_INTENTS } from "../services/messageRequestVocab";

// label (as rendered on a channel) → canonical intent key. Both the full label
// and the shorter filterLabel are indexed, lower-cased.
const LABEL_TO_KEY = MESSAGE_REQUEST_INTENTS.reduce((acc, it) => {
  acc[it.label.toLowerCase()] = it.key;
  acc[it.filterLabel.toLowerCase()] = it.key;
  return acc;
}, {});

const KEY_SET = new Set(MESSAGE_REQUEST_INTENTS.map((it) => it.key));

// deriveChannelIntent — the channel's intent key, or null when none is stamped.
// Prefers an explicit key field (tp_intent / request_intent / intent), then
// normalizes the human label the backend stamps for display.
export const deriveChannelIntent = (channelData) => {
  const data = channelData || {};
  const explicit = data.tp_intent || data.request_intent || data.intent;
  if (explicit && KEY_SET.has(String(explicit))) return String(explicit);
  const label = data.tp_intent_label || data.request_intent_label;
  if (label) {
    const key = LABEL_TO_KEY[String(label).toLowerCase().trim()];
    if (key) return key;
  }
  return null;
};

// The DM intent chip set (D11): "All" then the six intents, in the vocabulary
// order. Counts are supplied DM-scoped by the caller.
export const DM_INTENT_CHIPS = [
  { key: "all", label: "All" },
  ...MESSAGE_REQUEST_INTENTS.map((it) => ({
    key: it.key,
    label: it.filterLabel,
  })),
];

export default deriveChannelIntent;
